// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upcoming-buybox{.offer-container:nth-child(2n){background:#111924}.offer-container:nth-child(2n-1){background:#0c131e}}", ""]);
// Exports
module.exports = exports;
